import { render, staticRenderFns } from "./OrderPlaceField.vue?vue&type=template&id=5399b79c"
import script from "./OrderPlaceField.vue?vue&type=script&lang=js"
export * from "./OrderPlaceField.vue?vue&type=script&lang=js"
import style0 from "./OrderPlaceField.vue?vue&type=style&index=0&id=5399b79c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports